import bootstrap from 'bootstrap/dist/js/bootstrap.js';

// Import Swiper core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';

// Import Fancybox
import { Fancybox } from '@fancyapps/ui';

// Import Headroom.js
import Headroom from 'headroom.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    //------------------------------------------------//
    //------------ SMOOTH SCROLL TO ANCHOR -----------//
    //------------------------------------------------//
    // Function scrolls page to desired element with ID
    // More exceptions may need to be added for various Bootstrap features (ex. tabs, collapse, etc)

    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ){
        // Set offset from top
        var offset = -100;
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top + offset,
          }, 200, function () {
            // Callback after animation
            // Must change focus!
            var $target = $(target).find('.container');
            $target.focus();
            if ($target.is(':focus')) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            }
          });
        }
      }
    });

    //------------------------------------------------//
    //-------------- SELECT PLACEHOLDER --------------//
    //------------------------------------------------//
    // Adds a class to select inputs while placeholder option is selected
    // Mostly used to match font colors since there is no way to target via CSS

    function select_placeholder() {
      $('select').addClass('placeholder');
      $('select').change(function(e) {
          var select = e.target;
          var option = select.options[select.selectedIndex];
          if ($(option).hasClass('gf_placeholder')) {
              $(select).addClass('placeholder');
          } else {
              $(select).removeClass('placeholder');
          }
      });
    }

    select_placeholder();

    // Reinit on Gravity Forms render
    // $(document).on('gform_post_render', function(event, form_id, current_page) {
    //   select_placeholder();
    // });

    //------------------------------------------------//
    //-------------- MOBILE MENU LOGIC ---------------//
    //------------------------------------------------//

    var mobile_menu_el = document.getElementById('mobile_menu'),
    mobile_menu_toggle = document.getElementById('mobile_menu_toggle');


    if (mobile_menu_el) {
      var mobile_menu_offcanvas = new bootstrap.Offcanvas(mobile_menu_el)

      mobile_menu_el.addEventListener('shown.bs.offcanvas', function () {
        mobile_menu_toggle.classList.add('is-active');
      });

      mobile_menu_el.addEventListener('hidden.bs.offcanvas', function () {
        mobile_menu_toggle.classList.remove('is-active');

        // Reset mobile menu when closed
        $('.tif-mobile-menu .menu-wrapper .menu-checkbox').prop('checked', false);
      });

      mobile_menu_resize();
      $(window).resize(mobile_menu_resize);
    }

    function mobile_menu_resize() {
      var window_width = $(window).outerWidth(),
          threshold = 992;

      if (window_width >= threshold) {
        mobile_menu_offcanvas.hide();
      }
    }

    $('.tif-mobile-menu .menu-wrapper #panel-reset').each(function() {
      $(this).on('click', function() {
        $(this).closest('.has-sub-menu').find('.menu-checkbox').prop('checked', false);
      });
    });

    //------------------------------------------------//
    //----------------- PANEL SWIPER -----------------//
    //------------------------------------------------//

    const panels_slider_el = document.querySelectorAll('[id^="panel_slider_module_"]');

    panels_slider_el.forEach(el => {
      let panels_slider_content_el = new Swiper ('#' + el.id + ' .swiper', { // eslint-disable-line no-unused-vars
        navigation: {
          nextEl: '#' + el.id + ' .swiper-button-next',
          prevEl: '#' + el.id + ' .swiper-button-prev',
        },
        slidesPerView: 'auto',
      });
    });

    //------------------------------------------------//
    //------------- PRODUCT IMAGE SWIPER -------------//
    //------------------------------------------------//

    var image_thumbs = new Swiper('.product-image-thumbs', {
      spaceBetween: 10,
      slidesPerView: 3,
      // freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      loop: true,
      navigation: {
        nextEl: '.tif-product-image-slider .swiper-button-next',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },

    });
    var product_image_slider = new Swiper('.product-image-slider', { // eslint-disable-line no-unused-vars
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: '.tif-product-image-slider .swiper-button-next',
      },
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true,
      },
      thumbs: {
        swiper: image_thumbs,
      },
    });

    // image_thumbs.controller.control = product_image_slider;
    // product_image_slider.controller.control = image_thumbs;

    //------------------------------------------------//
    //------------------- FANCYBOX -------------------//
    //------------------------------------------------//

    Fancybox.bind('[data-fancybox]', {
      placeFocusBack: false,
    });

    //------------------------------------------------//
    //----------------- GALLERY TABS -----------------//
    //------------------------------------------------//

    $('.gallery-dropdown').find('.dropdown-menu button').on('click', function(e){
      e.preventDefault;

      var selText = $(this).text()
      var selID = $(this).attr('id')

      $(this).parents('.dropdown').find('.dropdown-toggle').html(selText)
      $(this).parents('.dropdown-menu').toggleClass('show');
      $(this).parents('.dropdown').find('.dropdown-toggle').toggleClass('show')
      $(this).parents('.dropdown').find('.dropdown-toggle').attr('aria-expanded', 'false')

      var ID_array = selID.split('-')
      var tab_button = 'gallery-' + ID_array[1] + '-' + ID_array[2] + '-tab'
      $('#' + tab_button).parents('.nav-pills').find('button').attr('aria-selected', 'false')
      $('#' + tab_button).parents('.nav-pills').find('button').removeClass('active');
      $('#' + tab_button).addClass('active')
      $('#' + tab_button).attr('aria-selected', 'true');

    })

    $('.tabs').find('.nav-pills button').on('click', function(e){
      e.preventDefault

      var selID = $(this).attr('id')
      var ID_array = selID.split('-')
      var tab_link = 'gallery-' + ID_array[1] + '-' + ID_array[2] + '-link'

      var text_var = $('#' + tab_link).text()
      $('#' + tab_link).parents('.dropdown').find('.dropdown-toggle').text(text_var)
      $('#' + tab_link).parents('.dropdown').find('.dropdown-menu .nav-item .nav-link').attr('aria-selected', 'false')
      $('#' + tab_link).attr('aria-selected', 'true')

      return false;
    })

    //------------------------------------------------//
    //--------------- FULL WIDTH SLIDER --------------//
    //------------------------------------------------//

    const full_image_slider_el = document.querySelectorAll('[id^="full_image_slider_"]');

    full_image_slider_el.forEach(el => {
      let full_image_slider_content_el = new Swiper ('#' + el.id + ' .slider-wrapper .swiper', { // eslint-disable-line no-unused-vars
        loop: true,
        pagination: {
          el: '#' + el.id + ' .slider-wrapper .swiper .swiper-pagination', clickable: true,
        },
        navigation: {
          nextEl: '#' + el.id + ' .slider-wrapper .swiper .swiper-button-next',
          prevEl: '#' + el.id + ' .slider-wrapper .swiper .swiper-button-prev',
        },
      });
    });

    //------------------------------------------------//
    //------------------ IMAGE SLIDER ----------------//
    //------------------------------------------------//

    const image_slider_el = document.querySelectorAll('[id^="image_slider_"]');

    image_slider_el.forEach(el => {
      let image_slider_content_el = new Swiper ('#' + el.id + ' .slider-wrapper .swiper', { // eslint-disable-line no-unused-vars
        loop: false,
        navigation: {
          nextEl: '#' + el.id + ' .swiper-button-next',
          prevEl: '#' + el.id + ' .swiper-button-prev',
        },
        slidesPerView: 'auto',
      });
    });

    //------------------------------------------------//
    //---------------- REVIEWS SLIDER ----------------//
    //------------------------------------------------//

    const reviews_slider_el = document.querySelectorAll('[id^="reviews_slider_module_"]');

    reviews_slider_el.forEach(el => {
      let reviews_slider_content_el = new Swiper ('#' + el.id + ' .swiper', { // eslint-disable-line no-unused-vars
        navigation: {
          nextEl: '#' + el.id + ' .title-wrapper .swiper-button-next',
          prevEl: '#' + el.id + ' .title-wrapper .swiper-button-prev',
        },
        slidesPerView: 'auto',
      });
    });

    //------------------------------------------------//
    //---------------- SUB NAVIGATION ----------------//
    //------------------------------------------------//

    const sub_navigation_el = document.getElementById('sub_navigation');

    let sub_navigation_slider_el = new Swiper(sub_navigation_el, { // eslint-disable-line no-unused-vars
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      resistanceRatio: 0,
      // breakpoints: {
      //   992: {
      //     allowTouchMove: false,
      //   },
      // },
      navigation: {
        nextEl: '.tif-sub-navigation' + ' .swiper-button-next',
        prevEl: '.tif-sub-navigation' + ' .swiper-button-prev',
      },
    });

    //------------------------------------------------//
    //------------- MULTI-STEP FORM LOGIC ------------//
    //------------------------------------------------//
    // Increases/decreases pagination in sidebar
    // Shows/hides extra panel on last page

    $(document).bind('gform_post_render', function (event, formId, current_page) { // eslint-disable-line no-unused-vars
      var $sidebar = $('.tif-multi-form .sidebar-wrapper');
      var maxPage = parseInt($sidebar.data('max-page'), 10);
      var currentPage = parseInt(current_page, 10);
      var isSinglePage = Number.isNaN(currentPage) || maxPage <= 1;

      $sidebar.find('.counter-wrapper ul li').each(function() {
        var page_number = $(this).data('count');

        if (current_page == page_number) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }

        if (current_page > page_number) {
          $(this).addClass('done');
        } else {
          $(this).removeClass('done');
        }

      });

      if (isSinglePage || currentPage == maxPage) {
        $('.tif-multi-form .sidebar-wrapper .panel.panel-1').removeClass('active');
        $('.tif-multi-form .sidebar-wrapper .panel.panel-2').addClass('active');
      } else {
        $('.tif-multi-form .sidebar-wrapper .panel.panel-2').removeClass('active');
        $('.tif-multi-form .sidebar-wrapper .panel.panel-1').addClass('active');
      }

    });

    $(document).on('gform_confirmation_loaded', function(event, formId) { // eslint-disable-line no-unused-vars
      $('.tif-multi-form .sidebar-wrapper').addClass('d-none');
      $('.tif-multi-form .form-wrapper').attr('class', 'form-wrapper col-24');
      $('.tif-multi-form .inner').attr('class', 'inner');
      $('.tif-multi-form .inner').addClass('tif-py-100 col-24');
    });

    //------------------------------------------------//
    //------------------ HEADROOM.JS -----------------//
    //------------------------------------------------//

    const header = document.querySelector('.header-wrapper .tif-navigation');

    let options = {
      offset: 60,
    };

    if (header) {
      const headroom = new Headroom(header, options);
      headroom.init();
    }

    //------------------------------------------------//
    //---------------- MEGA MENU LOGIC ---------------//
    //------------------------------------------------//
    // Built to support multiple mega menu templates

    var offcanvasElementList = [].slice.call(document.querySelectorAll('.tif-mega-menu')),
        navItemList = [].slice.call(document.querySelectorAll('.tif-navigation a[aria-controls]')),
        eventToggle = document.querySelector('.tif-navigation').getAttribute('data-toggle-event'),
        hoverSubmenu = false,
        hoverNavItem = null,
        timeoutHandler = null,
        timer = 400;

    if (offcanvasElementList) {
      var offcanvasList = offcanvasElementList.map(function (offcanvasEl) {
        return new bootstrap.Offcanvas(offcanvasEl)
      });

      offcanvasList.forEach(el => {

        // Toggle navigation active state
        el._element.addEventListener('show.bs.offcanvas', function() {
          $('.tif-navigation a[aria-controls="'+ el._element.id +'"]').attr('aria-expanded', 'true');
        });

        el._element.addEventListener('hidden.bs.offcanvas', function() {
          $('.tif-navigation a[aria-controls="'+ el._element.id +'"]').attr('aria-expanded', 'false');
        });

        // Hover events for mega menu
        if (eventToggle) {
          el._element.addEventListener('mouseenter', function() {
            el.show();
            hoverSubmenu = true;
          });

          el._element.addEventListener('mouseleave', function() {
            setTimeout(function() {
              if (!hoverNavItem) {
                el.hide();
                hoverSubmenu = false;
              }
            }, timer);
          });
        }
      });

      // Hover events for navigation
      if (eventToggle) {
        if (navItemList) {
          navItemList.forEach(el => {
            let target = $(el).attr('data-bs-target'),
                offcanvas = bootstrap.Offcanvas.getInstance(target);

            el.addEventListener('mouseenter', function() {
              hoverNavItem = el;
              hoverSubmenu = false;

              window.clearTimeout(timeoutHandler);

              offcanvasList.forEach(_el => {
                if (_el._element.id != $(el).attr('aria-controls')) {
                  _el.hide();
                }
              });

              setTimeout(function() {
                offcanvas.show();
              }, timer);
            });

            el.addEventListener('mouseleave', function() {
              hoverNavItem = null;

              timeoutHandler = setTimeout(function() {
                if (!hoverSubmenu) {
                  offcanvas.hide();
                }
              }, timer);
            });

          });
        }
      }

      mega_menu_resize();
      $(window).resize(mega_menu_resize);
    }

    function mega_menu_resize() {
      var window_width = $(window).outerWidth(),
          threshold = 992;

      if (window_width < threshold) {
        offcanvasList.forEach(el => {
          if (el._isShown) {
            el.hide();
          }
        });
      }
    }

    //------------------------------------------------//
    //---------------- MEDIA CAROUSEL ----------------//
    //------------------------------------------------//

    const media_slider_el = document.querySelectorAll('[id^="media_slider_"]');

    media_slider_el.forEach(el => {

      // if number of slides is greater than 1, init Swiper
      const slide_count = el.querySelector('.swiper').getAttribute('data-count');

      el.querySelectorAll('.swiper-slide.video').forEach(slide => {
        const playButton = slide.querySelector('.btn-play');
        const iframe = slide.querySelector('iframe');
        const ratio = slide.querySelector('.ratio');

        if (iframe) {
          const baseSrc = iframe.getAttribute('src');
          const autoplaySrc = baseSrc.indexOf('?') !== -1 ? baseSrc + '&autoplay=1' : baseSrc + '?autoplay=1';

          iframe.setAttribute('data-src', baseSrc);
          iframe.setAttribute('data-autoplay-src', autoplaySrc);
        }

        if (playButton && iframe && ratio) {
          playButton.addEventListener('click', () => {
            iframe.setAttribute('src', iframe.getAttribute('data-autoplay-src'));
            ratio.classList.add('is-playing');
          });
        }
      });

      if (slide_count <= 1) {
        return;
      }

      const media_slider_content_el = new Swiper('#' + el.id + ' .swiper', { // eslint-disable-line no-unused-vars
        navigation: {
          nextEl: '#' + el.id + ' .title-wrapper .swiper-button-next',
          prevEl: '#' + el.id + ' .title-wrapper .swiper-button-prev',
        },
        slidesPerView: 1.1,
        spaceBetween: 25,
      });

      const resetMediaSlides = () => {
        el.querySelectorAll('.swiper-slide.video').forEach(slide => {
          const iframe = slide.querySelector('iframe');
          const ratio = slide.querySelector('.ratio');
          const baseSrc = iframe ? iframe.getAttribute('data-src') : null;

          if (iframe && baseSrc && iframe.getAttribute('src') !== baseSrc) {
            iframe.setAttribute('src', baseSrc);
          }

          if (ratio) {
            ratio.classList.remove('is-playing');
          }
        });
      };

      media_slider_content_el.on('slideChange', resetMediaSlides);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
